/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

const copyTextToClipboard = (text: string): Promise<void> => window.navigator.clipboard.writeText(text);

export {
    copyTextToClipboard,
};
